var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 62,
    viewBox: "0 0 73 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5861 8.76011C44.5861 13.2173 40.9704 21.0142 36.5 21.0142C32.0297 21.0142 28.4139 13.2305 28.4139 8.76011C28.4981 6.67368 29.3862 4.70071 30.8922 3.25425C32.3982 1.80779 34.4053 1 36.4935 1C38.5816 1 40.5888 1.80779 42.0948 3.25425C43.6008 4.70071 44.4888 6.67368 44.573 8.76011H44.5861Z",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8542 43.7343C19.8542 39.3196 21.608 35.0858 24.7296 31.9641C27.8513 28.8425 32.0851 27.0887 36.4998 27.0887C40.9145 27.0887 45.1483 28.8425 48.27 31.9641C51.3916 35.0858 53.1453 39.3196 53.1453 43.7343",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7551 14.1114C64.7551 17.8849 61.6916 24.6299 57.9181 24.6299C54.1446 24.6299 51.0811 17.8323 51.0811 14.1114C51.0811 12.2964 51.8021 10.5557 53.0855 9.27227C54.3689 7.98884 56.1096 7.26782 57.9247 7.26782C59.7397 7.26782 61.4804 7.98884 62.7638 9.27227C64.0472 10.5557 64.7683 12.2964 64.7683 14.1114H64.7551Z",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3983 32.6897C51.4899 31.1065 53.9817 30.1384 56.5935 29.8943C59.2053 29.6502 61.8334 30.1398 64.1821 31.308C66.5308 32.4762 68.5069 34.2766 69.888 36.5068C71.2692 38.7369 72.0006 41.3082 72 43.9314",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24459 14.1114C8.24459 17.8849 11.3081 24.6299 15.0816 24.6299C18.8551 24.6299 21.9187 17.8323 21.9187 14.1114C21.9187 12.2964 21.1976 10.5557 19.9142 9.27227C18.6308 7.98884 16.8901 7.26782 15.075 7.26782C13.26 7.26782 11.5193 7.98884 10.2359 9.27227C8.95247 10.5557 8.23145 12.2964 8.23145 14.1114H8.24459Z",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6016 32.6897C21.5101 31.1065 19.0182 30.1384 16.4065 29.8943C13.7947 29.6502 11.1666 30.1398 8.81786 31.308C6.46916 32.4762 4.49306 34.2766 3.11191 36.5068C1.73076 38.7369 0.999356 41.3082 1 43.9314",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5116 48.5464C21.5157 52.0139 23.619 55.0613 26.5049 57.2301C29.3907 59.3988 32.903 60.5714 36.5129 60.5714C40.1228 60.5714 43.635 59.3988 46.5209 57.2301C49.4068 55.0613 51.51 52.0139 52.5142 48.5464",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 36.7131V52.4909",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6111 44.6019H44.3888",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.e5e4ff5747983e1fbf117ffbacb046ee.svg";
export { ForwardRef as ReactComponent };